<template>
  <v-app @mouseover.native="onMouseMoveOver" id="inspire">
    <div id="app">
      <!-- <top-navbar v-if="checkLocalStorageUserId()"></top-navbar> -->
      <flash-message class="myCustomClass" id="myCustomClass"></flash-message>
      <router-view></router-view>
      <logOffDialog v-if="dialog && window.location.pathname!='/login'" :dialog="dialog" @closeDialog="closeDialog"/>
      <form id="logout-form" action="/user/logout" method="POST" style="display: none;">@csrf</form>

      <input type="hidden"
        name="csrftoken"
        value="{% csrf_token %}"/>
    </div>
  </v-app>
</template>

<script>
// import TopNavbar from "./components/TopNavbar.vue";
import { EventBus } from './main.js';
import logOffDialog from './components/Dialogs/LoggOffDialog'
export default {
  name: 'App',
  components: {
    // TopNavbar,
    logOffDialog
  },
  mounted(){
    this.timeChecker()
    EventBus.$on("logOffDialog", (status) => {
      if(window.location.pathname!='/login') this.dialog = true
    });
  },

    data () {
      return {
        dialog: false,
      }
    },
  methods: {
    closeDialog(){
      this.dialog = false
    },
    timeChecker() {
      let app = this;
      var storedTimeStamp = localStorage.getItem("lastTimeStamp");
      app.timeCompare(storedTimeStamp);
    },
    timeCompare(timeString) {
      let app = this;
      var maxMinutes = 0.5 * 0.1 // * 2; // means (1min * 60 * 2) = 2 hours //GREATER THEN 1440 MIN OR 24 HOURS.
      var currentTime = new Date();
      var pastTime = new Date(timeString);
      var timeDiff = currentTime - pastTime;
      var minPast = Math.floor(timeDiff / 60000);
      if (timeString) {
        if (minPast >= maxMinutes) {
          let rememberMe = localStorage.getItem("remember_me");
          localStorage.clear();
          if (rememberMe) localStorage.setItem("remember_me", rememberMe);
          this.$router.push('/login');
          return false;
        } else {
          EventBus.$emit('logoutEvent', 'logout');
        }
      }
    },
    onMouseMoveOver() {
      if (typeof Storage !== "undefined") {
        var timeStamp = new Date();
        localStorage.setItem("lastTimeStamp", timeStamp);
      }
    },
    // checkLocalStorageUserId(){
    //   let user_id = localStorage.getItem("user_id");
    //   if(user_id && user_id!="0"){
    //     return true
    //   }
    //   return false
    // }
  }
}
</script>

<style>
#app {  
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}

body {
  background-color: #e5e5e5;
}
</style>
